import { LayoutComponent } from '../LayoutComponent';
import Refresh from '@spectrum-icons/workflow/Refresh';
import styles from './RefreshButtonComponent.module.css';
import { View } from '@adobe/react-spectrum';

export interface IRefreshButtonProps {
    percentWidth?: number;
}

function RefreshButton ({ percentWidth }: IRefreshButtonProps) {
    const handleRefresh = () => {
        // console.log('Refresh');
        window.location.reload();
    }
    return (

        <View>
            <button className={styles.refreshButton} style={{ width: percentWidth ? `${percentWidth}%` : '100%' }} onClick={handleRefresh}>
                <Refresh size={'S'} />
            </button></View>

    );
}

export const RefreshButtonComponent = LayoutComponent(RefreshButton);